export default {
  "get|faq/getlist": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          question: "Trynibusは何のサイトですか？",
          answer:
            "野村證券が提供する企業・業界分析業務に必要な全てを備える情報プラットフォームです。",
        },
        {
          question: "どんなコンテンツがありますか？",
          answer:
            "非上場企業を含む国内100万社以上、海外3万7千社の数値情報、定性情報、約550の業界レポートなど、企業・業界分析に必要なコンテンツを網羅しています。日経だから提供できる確かな情報で企業・業界分析を効率化します。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "事業企画、経営企画、営業企画をはじめ、企業・業界分析に関わる様々なビジネスシーンで活用頂いています。",
        },
        {
          question: "どんな業務で利用できますか？",
          answer:
            "<p>インターネットにつながる環境があれば、どこからでもご利用頂けます。</p><h4>OS</h4><p>Microsoft Windows 10以降</p><h4>推奨ブラウザ</h4><p>・Microsoft Internet Explorer 11<br />・Firefox 通常版（最新版での動作を確認）<br />・Google Chrome（最新版での動作を確認）</p>",
        },
      ],
    };
  },
};
